import React from "react";
import { motion } from "framer-motion";
import "./ServiceSection.css";
import { useNavigate } from "react-router-dom"; 
const services = [
  { title: " Visual Identity", img: "https://static.wixstatic.com/media/d56fdc_bf2c7475debe42b986cc867cfbe3e59f~mv2.png/v1/fill/w_1098,h_706,al_c,q_90,usm_0.66_1.00_0.01,enc_avif,quality_auto/Beige%20and%20Yellow%20Illustrative%20Creative%20Portofolio%20Presentation.png", link: "#" },
  { title: "Packaging & Product Branding", img: "https://static.wixstatic.com/media/d56fdc_e60e5b4919af42668defb269a37d6e59~mv2.png/v1/fill/w_996,h_616,al_c,q_90,usm_0.66_1.00_0.01,enc_avif,quality_auto/Blue%20and%20Yellow%20Illustrative%20Supply%20Chain%20Presentation.png", link: "#" },
  { title: "Brand Strategy", img: "https://static.wixstatic.com/media/d56fdc_cb3e5082d45940b28c0c305cffaafe30~mv2.png/v1/fill/w_962,h_680,al_c,q_90,usm_0.66_1.00_0.01,enc_avif,quality_auto/Orange%20and%20Brown%20Illustration%20Business%20Report%20Presentation%20(14).png", link: "#" },
  { title: "Personal Branding", img: "https://static.wixstatic.com/media/d56fdc_e79f4db61fd64753bae80df216759427~mv2.png/v1/fill/w_1146,h_708,al_c,q_90,usm_0.66_1.00_0.01,enc_avif,quality_auto/Cream%20and%20Green%20Illustrative%20Business%20Report%20Presentation.png", link: "#" },
];

const headingVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: { 
    opacity: 1, 
    y: 0,
    transition: { 
      duration: 0.8, 
      ease: "easeOut" 
    }
  },
};

const cardContainerVariants = {
  hidden: { opacity: 1 },
  visible: { 
    opacity: 1, 
    transition: { 
      staggerChildren: 0.2,
      delayChildren: 0.4 
    } 
  },
};

const cardVariants = {
  hidden: { opacity: 0, y: 50, scale: 0.95 },
  visible: { 
    opacity: 1, 
    y: 0, 
    scale: 1,
    transition: { 
      duration: 0.6, 
      ease: "easeOut" 
    },
  },
};

export default function MarketingSolutions() {
    const navigate = useNavigate();
  return (
    <div className="marketing-solutions-section">
      <motion.h2 
        className="marketing-solutions-heading"
        variants={headingVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.5 }}
      >
        BRANDING SOLUTIONS
      </motion.h2>

      <motion.div 
        className="marketing-solutions-cards-container"
        variants={cardContainerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
      >
        {services.map((service, index) => (
          <motion.div 
            className="marketing-solutions-card" 
            key={service.title} 
            variants={cardVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.5 }}
          >
             <div className="marketing-solutions-content-left">
              <h3 className="marketing-solutions-title">{service.title}</h3>
              <motion.button
                onClick={() => navigate("/lets-connect")}
                className="marketing-solutions-btn"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Know More
              </motion.button>
            </div>
            <div className="marketing-solutions-content-right">
              <motion.img 
                src={service.img} 
                alt={service.title} 
                className="marketing-solutions-image" 
                loading="lazy"
                draggable="false"
                whileHover={{ scale: 1.1, rotate: 5 }}
              />
            </div>
          </motion.div>
        ))}
      </motion.div>
    </div>
  );
}